import {Pipe, PipeTransform} from '@angular/core';

import {DimensionItem} from '@selpia/shared/models';


@Pipe({standalone: true, name: 'dataChunkTitle'})
export class DataChunkTitlePipe implements PipeTransform {
  transform(items: DimensionItem[], levelName: string | undefined): string {
    if (!levelName) {
      return '';
    }
    const itemForFocusLevel = items.find(item => item.dimension.levels.some(level => level.name === levelName));

    return itemForFocusLevel?.name || '';
  }
}
